import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import UserInfoCard from "@components/card/UserInfoCard";

import TabWithPanel from "@components/tab/TabWithPanel";
import {
  FollowStatus,
  InfoPanel,
  ShopListPanel,
} from "@pages/myPage/_component";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import useShopTotalCountStore from "@store/myPage/useShopTotalCount";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});

const UserInfoWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "0 2rem",
});

const MyPage = () => {
  const { getUserInfo } = useApiRequest();

  const { shopTotalCount, setShopTotalCount } = useShopTotalCountStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "1";

  useEffect(() => {
    if (
      sessionStorage.getItem("productAmount") !== undefined &&
      sessionStorage.getItem("productAmount") !== null
    ) {
      setShopTotalCount(sessionStorage.getItem("productAmount"));
    }
  }, []);

  useEffect(() => {
    const scrollPosition = sessionStorage.getItem("productListScrollPosition");

    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
    }
  }, []);

  // URL에서 tab 값을 가져오고, 바로 URL 파라미터 제거
  useEffect(() => {
    if (!searchParams.has("tab")) {
      setSearchParams({ tab: defaultTab }, { replace: true });
    }
  }, [defaultTab, searchParams, setSearchParams]);

  const { data: userInfo, isLoading: userLoading } = useQuery({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
  });

  const item = [
    {
      label: `SHOP (${shopTotalCount})`,
      key: "1",
      children: (
        <ShopListPanel
          sellerId={userInfo?.id}
          onTotalCount={setShopTotalCount}
        />
      ),
    },
    {
      label: "INFO",
      key: "2",
      children: <InfoPanel defaultTab={defaultTab} />,
    },
  ];

  const handleTabChange = (key: string) => {
    setSearchParams({ tab: key });
  };

  return (
    <Container>
      <UserInfoWrapper>
        <UserInfoCard myPage />

        <FollowStatus
          soldCnt={userInfo?.product_sold}
          follower={userInfo?.follower_count}
          following={userInfo?.following_count}
          userId={userInfo?.id}
          userName={userInfo?.nickname}
        />
      </UserInfoWrapper>

      <TabWithPanel
        item={item}
        defaultValue={defaultTab}
        onChange={handleTabChange}
      />
    </Container>
  );
};

export default MyPage;
